<template>
  <div id="app" v-cloak>
    <navigation></navigation>

    <router-view/>

    <page-footer></page-footer>
  </div>
</template>

<script>
  import Navigation from "./components/Navigation";
  import PageFooter from "./components/PageFooter";

  export default {
    components: {Navigation, PageFooter},
    data() {
      return {}
    },
    computed: {},
    methods: {}
  }
</script>